angular.module('app')
  .directive('uploadFile', function ($dialog) {
    return {
      restrict: 'A',
      scope: {
        file: '=uploadFile',
        onUpload: '&',
      },
      link(scope, element, attrs) {
        element.bind('change', () => {
          // we upload only if the user selected a file
          if (element[0].files[0]) {
            const progressBar = document.querySelector(attrs.progressBar);
            const formData = new FormData();

            formData.append('file', element[0].files[0]);

            $.ajax({
              beforeSend() {
                if (progressBar) {
                  progressBar.style.display = 'block';
                  progressBar.style.width = '0%';
                }

                scope.file = { uploading: true };
                scope.$apply();
              },
              xhr: () => {
                const xhr = new window.XMLHttpRequest();

                xhr.upload.addEventListener('progress', (e) => {
                  if (e.lengthComputable) {
                    progressBar.style.width = `${(e.loaded / e.total) * 100}%`;
                  }
                }, false);

                return xhr;
              },

              url: attrs.postUrl,
              processData: false,
              contentType: false,
              type: 'post',
              data: formData,
            })
              .done((response) => {
                scope.file = response.file;

                scope.onUpload({ file: scope.file });
              })
              .fail((response) => {
                if (response.status !== 422) {
                  $dialog.error('Whoops, looks like something went wrong.');
                } else {
                  const values = Object.values(response.responseJSON);

                  if (values[0][0]) {
                    $dialog.error(values[0][0]);
                  }
                }

                scope.file = null;
              })
              .always(() => {
                progressBar.style.display = 'none';
                progressBar.style.width = '0%';

                scope.$apply();

                // we reset this on purpose, otherwise we will not be able to "re-select" the same file for the second time
                element[0].value = '';
              });
          }
        });
      },
    };
  });
